module.exports = __webpack_public_path__ + "static/media/ico-close.ceba9311.svg";